import { useEffect } from 'react';
import DOMPurify from 'dompurify';
import { Button, Space, App } from 'antd';
import { BellOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { asyncMessageRead, setNoticeCenterOpen, removeNewMessage } from '@/app/reducers/noticeSlice';
import useNoticeNavigate from '@/hooks/useNoticeNavigate';
import { startNoticePoller, stopNoticePoller } from '@/utils/noticePoller';
import { storage } from '@/utils/storage';

export default function NotificationLayer() {
  const noticeNavigate = useNoticeNavigate();
  const dispatch = useDispatch();
  const { notification } = App.useApp();
  const { summaryDone, newMessageDone, newMessageList = [], isFreshLogin } = useSelector(state => state.notice || {});
  const bothDone = summaryDone && newMessageDone;

  useEffect(() => {
    if (isFreshLogin) {
      notification?.destroy();
    }
  }, [isFreshLogin, notification]);

  useEffect(() => {
    summaryDone && startNoticePoller();
    return () => stopNoticePoller();
  }, [summaryDone]);

  useEffect(() => {
    if (!storage.get('token')) {
      notification?.destroy();
      return;
    }
    if (!notification || !bothDone) return;
    newMessageList.forEach(item => {

      const key = `notice-${item.id}`;
      const isSummary = item.id === 'notice-summary';
      notification.info({
        key,
        message: item.title,
        icon: <BellOutlined style={{ color: '#1677ff' }} />,
        description: (
          <div>
            <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(item.content) }} />
            <div style={{ marginTop: 12, textAlign: 'right' }}>
              <Space>
                {!item.params?.approved && <Button size="small" onClick={() => {
                  if (!isSummary) {
                    noticeNavigate(item);
                  } else {
                    dispatch(setNoticeCenterOpen(true));
                  }
                  dispatch(removeNewMessage(item.id));
                  notification.destroy(key);
                }}>查看详情</Button>}
                <Button size="small" type="primary" onClick={() => {
                  if (!isSummary) {
                    dispatch(asyncMessageRead({ id: item.id }));
                  }
                  dispatch(removeNewMessage(item.id));
                  notification.destroy(key);
                }}>确认</Button>
              </Space>
            </div>
          </div>
        ),
        placement: 'topRight',
        duration: 0,
        onClose: () => {
          dispatch(removeNewMessage(item.id));
        }
      });
    });
  }, [newMessageList, notification, noticeNavigate, dispatch, bothDone]);

  return null;
}